export const hasAuth = (auth, data=Payload) => {
    const auths = typeof auth === 'string' ? [auth] : auth
    return auth.filter(a => data.groups.includes(a)).length > 0
}



// WEBPACK FOOTER //
// ./src/auth.js